export const FirstNameMaxLength = 1;
export const LastNameMaxLength = 3;

// General Values

export const MillisOnMinute = 60000;

export const DefaultTimeoutLimit = 180000; // 3 minutes
export const DefauilWaitTimeAfterTimeout = 20000; // 20 secs

export const isTimeoutActive = process.env.REACT_APP_IS_TIMEOUT_ACTIVE === 'true';

// User values

export const UserNameMinLength = 4;
export const UserNameMaxLength = 35;
export const UserLoginIDMinLength = 6;
export const UserLoginIDMaxLength = 16;
export const UserPasswordMinLength = 8;
export const UserPasswordMaxLength = 16;
export const UserPinCodeMinLength = 4;
export const UserPinCodeMaxLength = 6;


// Facility Values

export const MinTimeoutSession = 3;
export const MaxTimeoutSession = 15;

export const FacilityNameMaxLength = 100;

export const FacilityAddressMaxLength = 100;

export const FacilityZipCodeMaxLength = 10;
export const FacilityZipCodeMinLength = 5;


// Mobiles

export const MobileDeviceNameMaxLength = 50;
export const MobileSerialNumberMaxLength = 40;
export const MobileSerialNumberMinLength = 10;
export const MobileModelMaxLength = 100;
export const MobileAssetTagMaxLength = 20;


// Patient
export const PatientGestationalAgeMinValue = 18;
export const PatientGestationalAgeMaxValue = 45;
export const PatientGestationalAgeStep = '0.01';
export const PatientEhrMaxLength = 16;
export const PatientFirstNameMaxLength = 1;
export const PatientFirstNameMinLength = 1;
export const PatientLastNameMaxLength = 3;
export const PatientLastNameMinLength = 2;
export const PatientBirthWeightMinValue = 0;
export const PatientBirthWeightMaxValue = 999;
export const PatientBirthWeightLimits = {
  lb: { min: 0.4, max: 23.0 },
  kg: { min: 0.2, max: 10.4 },
  g:  { min: 200, max: 10430 },
  oz: { min: 7.1, max: 368 },
};
export const PatientConceptualAgeMinValue = 18;
export const PatientConceptualAgeMaxValue = 150;
export const PatientConceptualAgeStep = '0.01';

export const PatientsPerPage = 12;

// Measurements
export const MaxNumberOfMeasurements = 30000;

// Feeding graph 
export const MinValuePressureGraph = 1;
export const MaxValuePressureGraph = 1.9;

export const MinValueBreathingGraph = 1.2;
export const MaxValueBreathingGraph = 2.2;


// HANDHELD
export const HandheldSerialNumberMaxLength = 9;
export const HandheldSerialNumberMinLength = 9;
export const HandheldFriendlyNameLength = 20;
export const HandheldModelMaxLength = 20;
export const HandheldSoftwareVersionMaxLength = 20;
export const HandheldPairingCodeMaxLength = 36;
export const HandheldPairingCodeMinLength = 36;

// Patient Dashboard
export const PatientCardMaxSessions = 3;
export const BigPatientCardMaxSessions = 5;

export const MaxTextSize = 10

// Time to resend code - OTP
export const InitialTimeLeftOTP = 90;

// Card size
export const SmallCardSize = 4;
export const MediumCardSize = 6;
export const LargeCardSize = 12;